import type { Annotations } from "../api/types";

export interface EditorListProps {
  annotations: Annotations;
}

// Editors = anyone whose name is currently attached to at least one POI,
// pin, frame, or note — a note on someone else's POI or pin counts as
// editing. Deletion of a user's last item (or last note) drops them off the
// list automatically — there is no separate "editor" record.
export function editorNames(annotations: Annotations): string[] {
  const names = new Set<string>();
  for (const p of annotations.pois) {
    names.add(p.createdBy.displayName);
    for (const n of p.notes ?? []) names.add(n.displayName);
  }
  for (const p of annotations.pins) {
    names.add(p.createdBy.displayName);
    for (const n of p.notes ?? []) names.add(n.displayName);
  }
  for (const f of annotations.frames) names.add(f.capturedBy.displayName);
  return Array.from(names);
}

export function EditorList({ annotations }: EditorListProps): JSX.Element | null {
  const names = editorNames(annotations);
  if (names.length === 0) return null;
  return (
    <span style={{ fontSize: 12, color: "#444" }}>
      Editors: {names.join(", ")}
    </span>
  );
}
